import { useDispatch } from 'react-redux';
import { store } from '../store/store';
import Logger from '../common/logger';
import { setIsLoading } from '../store/slices/globalSlice';
import { locationsApiSlice } from '../api/locations/locationsApiSlice';
import { setSelectedDepotDetails } from '../store/slices/depotSlice';

const fetchDepotLocations = async () => {
    const data = await store.dispatch(locationsApiSlice.endpoints.fetchDepotLocations.initiate(
        undefined,
        { forceRefetch: true },
    ));
    return data;
};

export const useFetchDeportLocations = (locationId: string) => {
    const dispatch = useDispatch();

    const fetchLocations = async () => {
        try {
            dispatch(setIsLoading(true));
            const response = await fetchDepotLocations();

            if (response.data) {
                const selectedDepotDetails = response.data?.find((item) => item.id === locationId);
                if (selectedDepotDetails) {
                    dispatch(setSelectedDepotDetails(selectedDepotDetails));
                }
            }
        } catch (error) {
            Logger('fetchDepotLocations').error(error);
        } finally {
            dispatch(setIsLoading(false));
        }
    };

    return fetchLocations;
};
